export const ScheduleDateDisplay = {
  DateAndTime: 'date-and-time',
  DateOnly: 'date-only',
  WithoutDate: 'without-date',
} as const;

export type ScheduleDateDisplay = (typeof ScheduleDateDisplay)[keyof typeof ScheduleDateDisplay];

interface Params {
  scheduleDate: string | null;
  scheduleTimeMinutes: string | null;
}

export function resolveScheduleDateDisplay({ scheduleDate, scheduleTimeMinutes }: Params): ScheduleDateDisplay {
  if (!scheduleDate) return ScheduleDateDisplay.WithoutDate;

  return scheduleTimeMinutes ? ScheduleDateDisplay.DateAndTime : ScheduleDateDisplay.DateOnly;
}
